<template>
    <div class="cd-timeline-content cd-timeline--log-card">
        <div class="cd-timeline-content-text">
            <div class="cd-timeline-content--staff" v-html="buildContent(oneLog)" />
            <span class="nowrap gray-60 fs-2">
                {{ oneLog.timestamp | dateFormatter('NORMAL_DATE_TIME', true) }}
            </span>
        </div>
    </div>
</template>

<script>
import IconMixin from '../../mixins/IconMixin';
import TimelineCardMixin from './TimelineCardMixin';
import TimelineWordingMixin from './TimelineWordingMixin';

export default {
    mixins: [IconMixin, TimelineCardMixin, TimelineWordingMixin],
    data() {
        return {
            lang: this.$parent.lang,
        };
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.cd-timeline--log-card {
    .cd-timeline-content--staff {
        display: inline-block;

        .cd-timeline-content--block {
            display: inline-block;
            vertical-align: middle;
        }

        .person-light {
            display: inline-block;
        }
        .person-light-avatar__container {
            .compass-avatar-name__name {
                font-weight: 600;
                cursor: auto;
                font-size: 14px;
            }

            &:hover {
                .compass-avatar-name__name {
                    color: $gray-80;
                }
            }
        }
    }
}
</style>
